module.exports = __webpack_public_path__ + "static/media/john_deere.53dc7885.png";